import { getEmpresaContexto } from 'app/utils/geralUtil';

function makeConciliacoes(extratos) {
  let extratosAux = [];
  extratos.forEach((extrato) => {
    const extratoAux = {
      id: extrato.id,
      contaPagarList: extrato?.contaPagarList ? makeConciliacoesContaPagar(extrato) : undefined,
      contaReceberList: extrato?.contaReceberList ? makeConciliacoesContaReceber(extrato) : undefined,
      transferencia: extrato?.transferenciaBancariaForm ? makeConciliacoesTransferencia(extrato) : undefined,
    };
    if (!extratoAux.contaPagarList) {
      delete extratoAux.contaPagarList;
    }
    if (!extratoAux.contaReceberList) {
      delete extratoAux.contaReceberList;
    }
    if (!extratoAux.transferenciaBancariaForm) {
      delete extratoAux.transferenciaBancariaForm;
    }
    extratosAux.push(extratoAux);
  });
  return extratosAux;
}

function makeConciliacoesContaReceber(extrato) {
  let contaReceberListAux = [];
  extrato.contaReceberList.forEach((receita) => {
    const contaReceberAux = {
      id: receita.id,
      categorias: makeCategoriasReceita(
        receita.categorias,
        extrato?.receitasDespesas
          ? receita?.valor
          : receita.formulario && !!extrato.valorFormulario && extrato.valorFormulario > 0
          ? extrato.valorFormulario
          : extrato.valorReceitaDespesa
      ),
      baixas: [
        {
          formaRecebimento: receita.formaRecebimento,
        },
      ],
      clientePessoaId: receita.cliente.pessoaId,
    };
    contaReceberListAux.push(contaReceberAux);
  });
  return contaReceberListAux;
}

function makeCategoriasReceita(categorias, valorFormulario) {
  let categoriasAux = [];
  categorias.forEach((categoria) => {
    const categoriaAux = {
      classeId: categoria.id,
      valorBruto: valorFormulario ? valorFormulario : categoria.valorBruto,
    };
    categoriasAux.push(categoriaAux);
  });
  return categoriasAux;
}

function makeConciliacoesContaPagar(extrato) {
  let contaPagarListAux = [];
  extrato.contaPagarList.forEach((despesa) => {
    const contaPagarAux = {
      id: despesa.id,
      categorias: makeCategoriasDespesa(
        despesa.categorias,
        extrato?.receitasDespesas
          ? despesa?.valor
          : despesa.formulario && !!extrato.valorFormulario && extrato.valorFormulario > 0
          ? extrato.valorFormulario
          : extrato.valorReceitaDespesa
      ),
      fornecedor: despesa.fornecedor,
      formaPagamento: despesa.formaPagamento,
      baixas: [
        {
          formaPagamento: despesa.formaPagamento,
          numeroCheque: despesa.numeroCheque,
        },
      ],
    };
    if (contaPagarAux.formaPagamento !== 'CHEQUE') {
      // delete contaPagarAux.baixas;
    }
    contaPagarListAux.push(contaPagarAux);
  });
  return contaPagarListAux;
}

function makeConciliacoesTransferencia(extrato) {
  let transferenciaBancariaAux = {};
  if (extrato.transferenciaBancaria) {
    transferenciaBancariaAux = { empresaId: getEmpresaContexto(), ...extrato.transferenciaBancaria };
  } else {
    transferenciaBancariaAux = {
      empresaId: getEmpresaContexto(),
      ...extrato.transferenciaBancariaForm,
    };
  }
  return transferenciaBancariaAux;
}

function makeCategoriasDespesa(categorias, valorFormulario) {
  let categoriasAux = [];
  categorias.forEach((categoria) => {
    const categoriaAux = {
      classe: { id: categoria.id },
      valorBruto: valorFormulario ? valorFormulario : categoria.valorBruto,
    };
    categoriasAux.push(categoriaAux);
  });
  return categoriasAux;
}

export default {
  makeConciliacoes,
  makeConciliacoesContaReceber,
  makeConciliacoesContaPagar,
  makeConciliacoesTransferencia,
};
